export default "__VITE_ASSET__DHkcjSEe__"